import { useTranslation } from "react-i18next";

/**
 * Storefront ke labels ke liye chhota Hindi dictionary (rulebook §1 "Ek click me Hindi").
 * Key = English/Hinglish text jo code me likha hai; value = Devanagari.
 * Jo key yahan nahi hai wo waise ka waisa dikhta hai — kabhi khaali nahi.
 * Product/brand/category ke naam translate NAHI hote (mandi me wahi naam chalte hain).
 *
 * Use: `const t = useCiT(); <b>{t("Cart")}</b>`
 */
const HI: Record<string, string> = {
  // recent additions — SEO/footer/PDP/cart ke naye labels
  "Aaj ka rate — poori list": "आज का रेट — पूरी लिस्ट",
  "Popular categories": "लोकप्रिय श्रेणियाँ",
  "Related categories": "मिलती-जुलती श्रेणियाँ",
  "About the brand": "ब्रांड के बारे में",
  "More about": "और जानें",
  "Unit weight": "प्रति यूनिट वज़न",
  "Dobara try karein": "दोबारा कोशिश करें",
  "Rate nahi mil paya. Internet check karke dobara koshish karein.":
    "रेट नहीं मिल पाया। इंटरनेट देख कर दोबारा कोशिश करें।",
  "Rudrapur, Uttarakhand": "रुद्रपुर, उत्तराखंड",
  "GST bill seedha ERP se": "GST बिल सीधे ERP से",
  "Sampark karein": "संपर्क करें",
  "Contact & godown addresses": "संपर्क और गोदाम के पते",
  "Ye order pehle hi ban chuka tha. Aapka cart waisa hi hai — dobara Confirm karein.":
    "यह ऑर्डर पहले ही बन चुका था। आपका कार्ट वैसा ही है — दोबारा Confirm करें।",

  // chrome
  Home: "होम",
  Search: "खोजें",
  Cart: "कार्ट",
  Orders: "ऑर्डर",
  Account: "खाता",
  Login: "लॉगिन",
  "Aaj ka rate": "आज का रेट",
  "Full rate list": "पूरी रेट लिस्ट",
  Shop: "खरीदें",
  "All products": "सभी प्रोडक्ट",
  "All categories": "सभी श्रेणियाँ",
  "Brands / companies": "ब्रांड / कंपनियाँ",
  "Track order": "ऑर्डर ट्रैक करें",
  "My orders": "मेरे ऑर्डर",
  "My Orders": "मेरे ऑर्डर",
  "Delivery addresses": "डिलीवरी पते",
  "Dealer / contractor account": "डीलर / ठेकेदार खाता",
  FAQs: "सवाल-जवाब",
  Company: "कंपनी",
  "About Chawla Ispat": "चावला इस्पात के बारे में",
  "Privacy policy": "गोपनीयता नीति",
  "Delete account": "खाता हटाएँ",
  "Rates incl. GST · Prices change daily": "रेट GST सहित · रेट रोज़ बदलते हैं",
  "Rates incl. GST": "रेट GST सहित",
  Amount: "रकम",
  "Website me dikkat? Batayein": "वेबसाइट में दिक्कत? बताएँ",
  "Dikkat batayein": "दिक्कत बताएँ",
  "Kya kaam nahi kar raha, kis page par — ek line kaafi hai. Team dekh legi.": "क्या काम नहीं कर रहा, किस पेज पर — एक लाइन काफ़ी है। टीम देख लेगी।",
  "Mil gaya — shukriya. Zaroorat padi to hum phone/WhatsApp par sampark karenge.": "मिल गया — शुक्रिया। ज़रूरत पड़ी तो हम फ़ोन/WhatsApp पर संपर्क करेंगे।",
  "Kya hua? (jaise: Add to cart kaam nahi kar raha)": "क्या हुआ? (जैसे: कार्ट में डालना काम नहीं कर रहा)",
  "Thoda detail (optional)": "थोड़ा विवरण (वैकल्पिक)",
  "Phone (optional, sirf sampark ke liye)": "फ़ोन (वैकल्पिक, सिर्फ़ संपर्क के लिए)",
  "Bhej nahi paye — WhatsApp par bata dein.": "भेज नहीं पाए — WhatsApp पर बता दें।",
  "Bhej rahe hain…": "भेज रहे हैं…",
  Bhejein: "भेजें",
  Items: "आइटम",
  "Rate roz update · GST included": "रेट रोज़ अपडेट · GST शामिल",

  // home
  "Steel, cement & building material —": "स्टील, सीमेंट और बिल्डिंग मटेरियल —",
  "seedha godown se": "सीधे गोदाम से",
  ", GST bill ke saath.": ", GST बिल के साथ।",
  "Rate kg/pcs me dekho, quantity daalo, order confirm karo. Payment cash ya approved credit — delivery nearest godown se.":
    "रेट किलो/पीस में देखें, मात्रा डालें, ऑर्डर कन्फर्म करें। पेमेंट कैश या अप्रूव्ड क्रेडिट — डिलीवरी नज़दीकी गोदाम से।",
  "Order in 3 steps": "3 स्टेप में ऑर्डर",
  "Search ya category chuno": "सर्च करें या श्रेणी चुनें",
  "Size, brand, thickness — sab filter me.": "साइज़, ब्रांड, मोटाई — सब फ़िल्टर में।",
  "Quantity daalo — kg ya pieces": "मात्रा डालें — किलो या पीस",
  "Rate GST ke saath dikhega, total turant.": "रेट GST के साथ दिखेगा, टोटल तुरंत।",
  "Confirm — cash / credit on delivery": "कन्फर्म — डिलीवरी पर कैश / क्रेडिट",
  "Online payment nahi; dealer credit approved account par.": "ऑनलाइन पेमेंट नहीं; डीलर क्रेडिट अप्रूव्ड खाते पर।",
  "Naye customer ka pehla order approval ke baad confirm hota hai (usually same day).":
    "नए ग्राहक का पहला ऑर्डर अप्रूवल के बाद कन्फर्म होता है (आमतौर पर उसी दिन)।",
  "Shop by category": "श्रेणी से खरीदें",
  "Popular this week": "इस हफ़्ते के लोकप्रिय",
  "Rate transparent": "रेट साफ़-साफ़",
  "Har item par rate GST ke saath — jo dikhe wahi bill me. Koi hidden charge nahi.": "हर आइटम पर रेट GST के साथ — जो दिखे वही बिल में। कोई छिपा चार्ज नहीं।",
  "Nearest godown se delivery": "नज़दीकी गोदाम से डिलीवरी",
  "Rudrapur ke 5 godowns me se sabse paas wala assign hota hai.": "रुद्रपुर के 5 गोदामों में से सबसे पास वाला मिलता है।",
  "GST bill, ERP se seedha": "GST बिल, सीधे ERP से",
  "Order LohaWala ERP me Sales Order banta hai — bill wahi se.": "ऑर्डर LohaWala ERP में सेल्स ऑर्डर बनता है — बिल वहीं से।",
  "Dealer credit": "डीलर क्रेडिट",
  "Approved dealer/contractor ko credit; naye customer cash on delivery.": "अप्रूव्ड डीलर/ठेकेदार को क्रेडिट; नए ग्राहक डिलीवरी पर कैश।",
  "Brands we stock": "हमारे ब्रांड",
  "+ more": "+ और",
  "Browse TMT Bar": "TMT बार देखें",
  "Bulk quote on WhatsApp": "WhatsApp पर बल्क रेट",
  items: "आइटम",
  categories: "श्रेणियाँ",
  "Uttarakhand delivery": "उत्तराखंड डिलीवरी",
  "Aapke aakhri orders · 1 click me dekhein": "आपके पिछले ऑर्डर · 1 क्लिक में देखें",
  "Pichla order dobara": "पिछला ऑर्डर दोबारा",

  // listing / product
  Item: "आइटम",
  Rate: "रेट",
  Qty: "मात्रा",
  Taxable: "टैक्सेबल",
  GST: "GST",
  Add: "जोड़ें",
  "In cart": "कार्ट में",
  View: "देखें",
  Available: "उपलब्ध",
  "Out of stock": "स्टॉक में नहीं",
  "Rudrapur godown": "रुद्रपुर गोदाम",
  "Rudrapur godown se": "रुद्रपुर गोदाम से",
  "Add to cart": "कार्ट में डालें",
  "Cart me add ho gaya": "कार्ट में जुड़ गया",
  "Cart update ho gaya": "कार्ट अपडेट हो गया",
  "Rate available nahi": "रेट उपलब्ध नहीं",
  "Products dekhein": "प्रोडक्ट देखें",

  // cart
  "Cart khaali hai": "कार्ट खाली है",
  'Product par "Add to cart" dabaiye — rate + GST yahin dikhega.': 'प्रोडक्ट पर "कार्ट में डालें" दबाएँ — रेट + GST यहीं दिखेगा।',
  "item · rates rechecked live": "आइटम · रेट लाइव जाँचे गए",
  "Order summary": "ऑर्डर सारांश",
  "Taxable value": "टैक्सेबल वैल्यू",
  Delivery: "डिलीवरी",
  "Order par tay": "ऑर्डर पर तय",
  Total: "कुल",
  Checkout: "चेकआउट",
  "Login & checkout": "लॉगिन और चेकआउट",
  "Kisi item ka rate nahi mila — usse hata kar aage badhein.": "किसी आइटम का रेट नहीं मिला — उसे हटाकर आगे बढ़ें।",
  "Payment: cash on delivery ya approved dealer credit. Online payment nahi.": "पेमेंट: डिलीवरी पर कैश या अप्रूव्ड डीलर क्रेडिट। ऑनलाइन पेमेंट नहीं।",
  "Rate server se, ERP jaisa hi hisaab": "रेट सर्वर से, ERP जैसा ही हिसाब",
  "GST invoice order number ke saath": "ऑर्डर नंबर के साथ GST बिल",
  "Isi cart ka WhatsApp quote": "इसी कार्ट का WhatsApp रेट",
  "Cart khaali karein": "कार्ट खाली करें",
  "Rate lock khatam.": "रेट लॉक खत्म।",
  "Naya rate lein.": "नया रेट लें।",
  "Rate refresh": "रेट रिफ्रेश",
  "Rate lock": "रेट लॉक",
  "baaki.": "बाकी।",
  "Steel rate roz badalta hai — abhi ka rate 15 min tak pakka. Time nikla to hum dobara rate dikhayenge, aap confirm karenge.":
    "स्टील का रेट रोज़ बदलता है — अभी का रेट 15 मिनट तक पक्का। समय निकला तो हम दोबारा रेट दिखाएँगे, आप कन्फर्म करेंगे।",
  "In stock": "स्टॉक में",
  Remove: "हटाएँ",

  // checkout
  "Login zaroori hai": "लॉगिन ज़रूरी है",
  "Order confirm karne ke liye phone number se login karein — cart waisa hi rahega.": "ऑर्डर कन्फर्म करने के लिए फ़ोन नंबर से लॉगिन करें — कार्ट वैसा ही रहेगा।",
  "Login / Sign up": "लॉगिन / साइन अप",
  "Cart par wapas": "कार्ट पर वापस",
  "Address & delivery": "पता और डिलीवरी",
  "Review & confirm": "जाँचें और कन्फर्म करें",
  "Delivery address": "डिलीवरी पता",
  "Naya address": "नया पता",
  "Godown pickup": "गोदाम से पिकअप",
  "Apna truck bhejo — loading free · Rudrapur godown, 9am–6pm": "अपना ट्रक भेजें — लोडिंग फ्री · रुद्रपुर गोदाम, 9am–6pm",
  "Naya delivery address": "नया डिलीवरी पता",
  "Naam (Site 2, Godown…)": "नाम (साइट 2, गोदाम…)",
  "Site incharge ka naam": "साइट इंचार्ज का नाम",
  "Phone (driver call karega)": "फ़ोन (ड्राइवर कॉल करेगा)",
  "Pincode (6 ank)": "पिनकोड (6 अंक)",
  "Plot / building / road *": "प्लॉट / बिल्डिंग / रोड *",
  "Landmark (optional)": "लैंडमार्क (वैकल्पिक)",
  "City *": "शहर *",
  State: "राज्य",
  "Address book me save karein": "एड्रेस बुक में सेव करें",
  "Delivery slot": "डिलीवरी समय",
  "Kal subah": "कल सुबह",
  "Kal shaam": "कल शाम",
  Parso: "परसों",
  "Driver call kare": "ड्राइवर कॉल करे",
  "Truck 5–10 ton · unloading site par aapki taraf se · exact time driver call karega.": "ट्रक 5–10 टन · अनलोडिंग साइट पर आपकी तरफ़ से · सही समय ड्राइवर कॉल करेगा।",
  Payment: "पेमेंट",
  "Cash on delivery": "डिलीवरी पर कैश",
  "Cash / UPI driver ko delivery par": "कैश / UPI ड्राइवर को डिलीवरी पर",
  "Sirf approved account · team confirm karegi": "सिर्फ़ अप्रूव्ड खाता · टीम कन्फर्म करेगी",
  "Bill details": "बिल विवरण",
  "GSTIN (bill par)": "GSTIN (बिल पर)",
  "Profile me GSTIN nahi": "प्रोफ़ाइल में GSTIN नहीं",
  "PO / site reference (optional)": "PO / साइट संदर्भ (वैकल्पिक)",
  "Note (optional)": "नोट (वैकल्पिक)",
  "Subah 9 baje se pehle bhej dena": "सुबह 9 बजे से पहले भेज देना",
  "Rate badal gaya tha. Upar naya total hai — theek lage to dobara Confirm dabayein.": "रेट बदल गया था। ऊपर नया टोटल है — ठीक लगे तो दोबारा कन्फर्म दबाएँ।",
  baaki: "बाकी",
  "Rate lock khatam — refresh karein": "रेट लॉक खत्म — रिफ्रेश करें",
  "Order ban raha hai…": "ऑर्डर बन रहा है…",
  "Confirm order": "ऑर्डर कन्फर्म करें",
  "Pehle delivery address chunein ya bharein.": "पहले डिलीवरी पता चुनें या भरें।",
  "Confirm par LohaWala ERP me Sales Order banega — order no. aur SMS turant.": "कन्फर्म पर LohaWala ERP में सेल्स ऑर्डर बनेगा — ऑर्डर नंबर और SMS तुरंत।",
  "Cart badlein": "कार्ट बदलें",
  "Rate badal gaya — naya total dekh kar dobara confirm karein.": "रेट बदल गया — नया टोटल देखकर दोबारा कन्फर्म करें।",
  "Login expire ho gaya — dobara login karein.": "लॉगिन खत्म हो गया — दोबारा लॉगिन करें।",
  "Order nahi ban paya. Thodi der baad try karein.": "ऑर्डर नहीं बन पाया। थोड़ी देर बाद कोशिश करें।",

  // order placed / my orders
  "Order mil gaya": "ऑर्डर मिल गया",
  "Order no.": "ऑर्डर नं.",
  Status: "स्थिति",
  "Approval pending": "अप्रूवल बाकी",
  "Pehle se bana hua": "पहले से बना हुआ",
  Confirmed: "कन्फर्म",
  Placed: "दर्ज",
  Dispatched: "रवाना",
  Delivered: "डिलीवर",
  Cancelled: "रद्द",
  Pending: "बाकी",
  All: "सभी",
  "Pehla order — team aaj confirm karegi": "पहला ऑर्डर — टीम आज कन्फर्म करेगी",
  "Sales team ko mil gaya": "सेल्स टीम को मिल गया",
  "GST invoice delivery ke saath": "GST बिल डिलीवरी के साथ",
  "SMS par order number + track link bhej diya": "SMS पर ऑर्डर नंबर + ट्रैक लिंक भेज दिया",
  "Grand total (incl. GST)": "कुल (GST सहित)",
  "Grand total": "कुल",
  "Continue shopping": "खरीदारी जारी रखें",
  "Help on WhatsApp": "WhatsApp पर मदद",
  Help: "मदद",
  "Details / Reorder": "विवरण / दोबारा ऑर्डर",
  "Reorder all": "सब दोबारा ऑर्डर",
  "Orders load nahi ho paye. Thodi der baad dobara try karein.": "ऑर्डर लोड नहीं हो पाए। थोड़ी देर बाद दोबारा कोशिश करें।",
  "Is filter me koi order nahi.": "इस फ़िल्टर में कोई ऑर्डर नहीं।",
  "Abhi koi website order nahi hai.": "अभी कोई वेबसाइट ऑर्डर नहीं है।",
  "Product chunein, quantity daalein, aur pehla order yahin se karein.": "प्रोडक्ट चुनें, मात्रा डालें, और पहला ऑर्डर यहीं से करें।",
  "GST included in total": "टोटल में GST शामिल",
  "Hamari team aaj confirm karegi.": "हमारी टीम आज कन्फर्म करेगी।",
  "Delivered — invoice ke liye WhatsApp karein.": "डिलीवर — बिल के लिए WhatsApp करें।",
  "Dispatch par truck number SMS/WhatsApp par milega.": "रवाना होने पर ट्रक नंबर SMS/WhatsApp पर मिलेगा।",
  "Order nahi mila.": "ऑर्डर नहीं मिला।",
  Godown: "गोदाम",
  "Nearest godown se dispatch": "नज़दीकी गोदाम से रवाना",
  "Cash / dealer credit": "कैश / डीलर क्रेडिट",
  "item cart me daal diye": "आइटम कार्ट में डाल दिए",

  // product page
  Back: "वापस",
  "Brand / company": "ब्रांड / कंपनी",
  "Item code": "आइटम कोड",
  "Sold in": "बिकता है",
  "sold in": "बिकता है",
  Brand: "ब्रांड",
  Category: "श्रेणी",
  "Abhi stock me nahi": "अभी स्टॉक में नहीं",
  "Total incl. GST": "कुल (GST सहित)",
  "incl. GST": "GST सहित",
  Specification: "विवरण",
  Value: "मान",
  Description: "जानकारी",
  "Rate roz update · GST alag": "रेट रोज़ अपडेट · GST अलग",
  Quantity: "मात्रा",
  "Rate × qty": "रेट × मात्रा",
  "Cart update karein": "कार्ट अपडेट करें",
  Update: "अपडेट",
  "Quote for bigger qty": "ज़्यादा मात्रा का रेट पूछें",
  "Get latest price (team se)": "ताज़ा रेट पूछें (टीम से)",
  "Delivery Rudrapur godown se, 1–2 din · pincode checkout par": "डिलीवरी रुद्रपुर गोदाम से, 1–2 दिन · पिनकोड चेकआउट पर",
  "GST invoice with order · cash / dealer credit": "ऑर्डर के साथ GST बिल · कैश / डीलर क्रेडिट",

  // listing page
  Filters: "फ़िल्टर",
  "Rate / unit": "रेट / यूनिट",
  "Rates incl. GST · quantity daal kar seedha Add": "रेट GST सहित · मात्रा डालकर सीधे जोड़ें",
  "Is naam/filter par kuch nahi mila — spelling badal kar ya category se dhoondhein.": "इस नाम/फ़िल्टर पर कुछ नहीं मिला — स्पेलिंग बदलकर या श्रेणी से ढूँढें।",
  "Bahut bada order?": "बहुत बड़ा ऑर्डर?",
  "5 ton+ par WhatsApp par special rate —": "5 टन+ पर WhatsApp पर खास रेट —",
  "quote maango": "रेट माँगें",

  // auth — login / signup / OTP / password
  "Sign in": "साइन इन",
  "New account": "नया खाता",
  "Sign in karein": "साइन इन करें",
  "Naya account banayein": "नया खाता बनाएँ",
  "Account nahi hai?": "खाता नहीं है?",
  "Pehle se account hai?": "पहले से खाता है?",
  "Order karne, rate lock karne aur apne purane order dekhne ke liye login karein.":
    "ऑर्डर करने, रेट लॉक करने और पुराने ऑर्डर देखने के लिए लॉगिन करें।",
  "Email ya phone number": "ईमेल या फ़ोन नंबर",
  "Email ya phone number daalein": "ईमेल या फ़ोन नंबर डालें",
  Password: "पासवर्ड",
  "Password daalein": "पासवर्ड डालें",
  "Password bhool gaye?": "पासवर्ड भूल गए?",
  "Password yaad aa gaya?": "पासवर्ड याद आ गया?",
  "Sign in ho raha hai…": "साइन इन हो रहा है…",
  "Login nahi ho paya": "लॉगिन नहीं हो पाया",
  "Phone number par OTP aayega. Yahi number aage aapka login ID rahega.":
    "फ़ोन नंबर पर OTP आएगा। यही नंबर आगे आपका लॉगिन ID रहेगा।",
  Naam: "नाम",
  "Aapka ya firm ka naam": "आपका या फर्म का नाम",
  "Naam zaroori hai": "नाम ज़रूरी है",
  "Mobile number": "मोबाइल नंबर",
  "OTP isi par aayega": "OTP इसी पर आएगा",
  "Phone number zaroori hai": "फ़ोन नंबर ज़रूरी है",
  "10 ank ka sahi mobile number daalein": "10 अंक का सही मोबाइल नंबर डालें",
  "Password zaroori hai": "पासवर्ड ज़रूरी है",
  "Password kam se kam 6 akshar ka ho": "पासवर्ड कम से कम 6 अक्षर का हो",
  "Kam se kam 6 akshar": "कम से कम 6 अक्षर",
  "Password dobara": "पासवर्ड दोबारा",
  "Wahi password dobara": "वही पासवर्ड दोबारा",
  "Dono password alag hain": "दोनों पासवर्ड अलग हैं",
  "OTP bhejein": "OTP भेजें",
  "OTP bhej rahe hain…": "OTP भेज रहे हैं…",
  "OTP bhej diya": "OTP भेज दिया",
  "OTP dobara bhej diya": "OTP दोबारा भेज दिया",
  "OTP daalein": "OTP डालें",
  "6 ank ka code bheja hai": "6 अंक का कोड भेजा है",
  "par.": "पर।",
  "Number badlein": "नंबर बदलें",
  "6 ank ka OTP daalein": "6 अंक का OTP डालें",
  "Verify karein": "वेरिफ़ाई करें",
  "Check kar rahe hain…": "चेक कर रहे हैं…",
  "OTP nahi aaya?": "OTP नहीं आया?",
  "Dobara bhejein": "दोबारा भेजें",
  "OTP galat hai — dobara try karein": "OTP गलत है — दोबारा कोशिश करें",
  "Number verify ho gaya": "नंबर वेरिफ़ाई हो गया",
  "Kuch galat ho gaya": "कुछ गलत हो गया",
  "Apna registered mobile number daalein — us par 6 ank ka OTP bhejenge.":
    "अपना रजिस्टर्ड मोबाइल नंबर डालें — उस पर 6 अंक का OTP भेजेंगे।",
  "Naya password": "नया पासवर्ड",
  "Naya password daalein": "नया पासवर्ड डालें",
  "Naya password rakhein — iske baad usi se sign in karein.":
    "नया पासवर्ड रखें — इसके बाद उसी से साइन इन करें।",
  "Password badlein": "पासवर्ड बदलें",
  "Badal rahe hain…": "बदल रहे हैं…",
  "Password badal gaya": "पासवर्ड बदल गया",
  "Rudrapur ka loha bazaar — ek login me": "रुद्रपुर का लोहा बाज़ार — एक लॉगिन में",
  "Aaj ka rate — GST sahit, roz update": "आज का रेट — GST सहित, रोज़ अपडेट",
  "Har order par GST bill": "हर ऑर्डर पर GST बिल",
  "Rudrapur godown se 1–2 din me delivery": "रुद्रपुर गोदाम से 1–2 दिन में डिलीवरी",
  "Dealer credit · godown pickup bhi": "डीलर क्रेडिट · गोदाम पिकअप भी",
  "Rate dekhne ke liye login zaroori nahi — login sirf order ke liye.":
    "रेट देखने के लिए लॉगिन ज़रूरी नहीं — लॉगिन सिर्फ़ ऑर्डर के लिए।",
  "Madad chahiye? WhatsApp karein": "मदद चाहिए? WhatsApp करें",

  // mobile search page (/searchpage)
  "Recent searches": "हाल की खोजें",
  Clear: "हटाएँ",
  "Top searches": "टॉप खोजें",
  Categories: "श्रेणियाँ",
  category: "श्रेणी",
  "TMT, GC sheet, 2x1 pipe — size ya brand bhi": "TMT, GC शीट, 2x1 पाइप — साइज़ या ब्रांड भी",
  'Size/brand bhi likh sakte hain — "12mm kamdhenu", "2x1 pipe", "ultratech 43".': 'साइज़/ब्रांड भी लिख सकते हैं — "12mm kamdhenu", "2x1 pipe", "ultratech 43"।',
  "Is naam par suggestion nahi mila — spelling badal kar dekhein, ya seedha search karein.": "इस नाम पर सुझाव नहीं मिला — स्पेलिंग बदलकर देखें, या सीधे खोजें।",
  "Phir bhi search karo": "फिर भी खोजें",
};

/** Hindi chuna ho to t("...") Devanagari deta hai, warna wahi text. */
export const useCiT = (): ((s: string) => string) => {
  const { i18n } = useTranslation();
  const hi = !!(i18n && i18n.language && i18n.language.startsWith("hi"));
  return (s: string) => (hi && HI[s]) || s;
};

export default useCiT;
